export default __webpack_public_path__ + "static/media/resume.c75e6005.png";